/**
 * Check if service should load the new questionnaire based on assessment config
 * @param service
 * @returns {number|*}
 */
export function isNewQuestionnaire (service) {
  const {
    fhir_questionnaire_repeat_id: repeatId,
    fhir_questionnaire_id: id,
    repeat: repeatFlag
  } = service

  if (repeatFlag && repeatId) {
    return repeatId
  } else if (!repeatFlag && id) {
    return id
  }
  return 0
}
